export const locale = {
    lang: 'fr',
    data: {
        NAVIGATION_BOARDS: 'Tableaux',
        NAVIGATION_SESSIONS: 'Ateliers',
        NAVIGATION_DOCUMENTS: 'Documents',
        NAVIGATION_DETAILS: 'À propos',
    }
};
